import { jsx as _jsx } from "react/jsx-runtime";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
// Toolbar limited to what the mobile renderer (react-native-render-html) and the
// backend sanitizer both support: headings, basic marks, lists, quote, links.
const MODULES = {
    toolbar: [
        [{ header: [2, 3, false] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote', 'link'],
        ['clean'],
    ],
};
const FORMATS = ['header', 'bold', 'italic', 'underline', 'list', 'blockquote', 'link'];
/** Rich-text (WYSIWYG) editor producing HTML, used for the article content. */
export function RichTextEditor({ value, onChange }) {
    return (_jsx("div", { className: "rich-text-editor bg-white rounded-lg", children: _jsx(ReactQuill, { theme: "snow", value: value, onChange: onChange, modules: MODULES, formats: FORMATS }) }));
}
